module.exports = __webpack_public_path__ + "static/img/bg_ready.62cc1e8d.jpg";